// import image from '../../assets/icon 1.png'
import society from "../../assets/Society.png"
import schools from "../../assets/school.png"
import winner from "../../assets/winner.png"
import comp from "../../assets/Competition.png"
import prize from "../../assets/prize.png"
export const countObjectData = [
  {
    img: schools,
    textTop: "2",
    textBottom: "Schools"
  },
  {
    img: society,
    textTop: "2",
    textBottom: "Societies"
  },
  {
    img: comp,
    textTop: "1",
    textBottom: "Competiton"
  },
  {
    img: winner,
    textTop: "3",
    textBottom: "Winners"
  },
  {
    img: prize,
    textTop: "5000",
    textBottom: "Worth prize"
  }
];